import React from 'react';
import { FormProvider, useForm } from 'react-hook-form';

import { OnboardingProvider } from '../../context';
import { useInitializeSteps } from '../../hooks/useInitializeSteps';
import { useProxyWizard } from '../../hooks/useProxyWizard';

import { layoutSteps, layoutStepsKeys, layoutDataDefault } from './constants';

import type { LayoutDataType } from './types';

const LayoutOwnAIMan_Maxim: React.FC = () => {
  const { proxyWizard, step } = useProxyWizard(layoutStepsKeys, layoutSteps);

  useInitializeSteps(proxyWizard, layoutStepsKeys);

  const form = useForm<LayoutDataType>({
    defaultValues: layoutDataDefault,
  });

  const StepComponent =
    layoutSteps[step as keyof typeof layoutSteps]?.component;

  if (!StepComponent) {
    return null;
  }

  return (
    <OnboardingProvider wizard={proxyWizard} steps={layoutSteps}>
      <FormProvider {...form}>
        <StepComponent />
      </FormProvider>
    </OnboardingProvider>
  );
};

export default LayoutOwnAIMan_Maxim;
